<template>
    <span v-if="team.length && userId" :title="user.name" class="d-flex align-items-center justify-content-start gap-2">
        <img v-if="!user.deleted" class="rounded shadow-z2 fit-cover" :class="[img_class]" :src="user | avatar_url" />
        <span :class="{'text-muted text-italic': user.deleted === true}">{{ user.name }}</span>
    </span>
</template>

<script>

export default {

    props: {
        // All team members
        team: {
            type: Array,
            default: () => []
        },
        // The user ID who is displayed
        userId: Number,
        
        // An alternative user object (name, avatar url) who is displayed when userId=0 (e.g., Client Space client)
        externalActor: {
            type: Object,
            default: () => null
        },

        img_class: {
            type: String,
            default: "thumb32"
        }
    },

    computed: {
        user(){
            return this.user_id == 0 ? this.externalActor : this.team.find(u => u.user_id == this.userId) || { name:  "[deleted]", avatar_url: false, deleted: true }
        }
    },

    /*
    methods: {
        init: function(){
            if(this.userId === undefined || this.team === undefined ){
                return;
            }
            if(this.userId === 0 && this.externalActor){
                this.user = this.externalActor
                return
            }

            let user = this.team.find(m => { return m.user_id ? (m.user_id == this.userId) : (m.id == this.userId) });
            if(user == undefined){
                console.error("[userbox] Member not found: #" + this.userId)
                user = { name:  "[deleted]", avatar_url: false, deleted: true }
            }
            else{
                user.avatar_url = Utils.avatar_url(user)
            }

            this.user = user
        }
    }
        */
}
</script>